<template>
    <v-stepper-content :step="step">
        <div class="subtitle text-center">Lakukan pembayaran sebesar</div>

        <div class="display-1 text-center font-weight-light my-4 mx-auto">
            Rp {{ price }}
        </div>

        <div class="subtitle text-center">Melalui</div>

        <v-row justify="center">
            <v-col
                cols="12"
                sm="10"
                md="8"
                lg="6"
            >
                <v-list>
                    <v-list-item>
                        <v-list-item-content>
                            Rek BTN: 001-750-161-032-6134 (a.n. Puja Chrisdianto
                            Manapa)
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-content>
                            Rek BCA: 584-501-1548 (a.n. Puja Chrisdianto Manapa)
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>

        <div class="subtitle text-center">
            Lakukan pembayaran sebelum tanggal {{ dueDate }}
        </div>

        <div class="text-center mt-4">
            <v-btn
                @click="$emit('nextStep')"
                color="primary"
                :disabled="!payment"
            >
                Selanjutnya
            </v-btn>
        </div>
    </v-stepper-content>
</template>

<script>
import priceFormat from '@/tools/priceFormat'
import dateToString from '@/tools/dateToString'

const PAYMENT_DAYS = 2

export default {
    props: {
        payment: {
            type: Object,
        },

        step: {
            type: String,
        },
    },

    computed: {
        price() {
            return this.$store.get('enrollment/selected@special_price')
                ? priceFormat(
                      this.$store.get('enrollment/selected@special_price')
                  )
                : priceFormat(this.payment.price)
        },

        dueDate() {
            const enrolled = new Date(this.payment.enrolled_at)
            enrolled.setDate(enrolled.getDate() + PAYMENT_DAYS)

            return dateToString(enrolled)
        },
    },
}
</script>
